import axios, { AxiosInstance } from "axios";
import { getJwt } from "./cookie-helpers";

class I18nService {
  private customerId: string;
  private lang: string;
  translationsApi: AxiosInstance;

  constructor(customerId: string, lang: string) {
    this.customerId = customerId;
    this.lang = lang;
    this.translationsApi = axios.create({
      baseURL: process.env.TRANSLATION_API_URL,
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
    });

    this.addBearerTokenInterceptor(this.translationsApi);
  }

  public async fetchTranslations(lang: string): Promise<Record<string, any>> {
    const cachedTranslations = sessionStorage.getItem(
      `translations_${lang}_${this.customerId}`
    );
    if (cachedTranslations) {
      return JSON.parse(cachedTranslations);
    }

    try {
      const response = await this.translationsApi.get(
        `/api/translations/${this.customerId}/${lang}`
      );

      sessionStorage.setItem(
        `translations_${lang}_${this.customerId}`,
        JSON.stringify(response.data)
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching translations: ", error);
      return {};
    }
  }

  public async init(): Promise<any> {
    const translations = await this.fetchTranslations(this.lang);
    return { translations, lang: this.lang };
  }

  private addBearerTokenInterceptor(api: AxiosInstance) {
    api.interceptors.request.use((config) => {
      //@ts-ignore
      config.headers["Authorization"] = "Bearer " + getJwt();
      return config;
    });
  }
}

export default I18nService;
